import { createAction } from 'Lib/reduxUtils';

import {
  CAPTCHA_APPEAL_BAN,
  CAPTCHA_VERIFY_FAILURE,
  CAPTCHA_VERIFY_NEW_USER,
  CAPTCHA_VERIFY_SUCCESS,
} from './constants';

export const captchaVerifyNewUser = createAction(
  CAPTCHA_VERIFY_NEW_USER,
  (token: string, vendor: string, suppressed?: boolean | null) => ({ token, vendor, suppressed })
);
export const captchaVerifySuccess = createAction(CAPTCHA_VERIFY_SUCCESS);
export const captchaVerifyFailure = createAction(CAPTCHA_VERIFY_FAILURE, (payload: any) => payload);

export const captchaAppealBan = createAction(
  CAPTCHA_APPEAL_BAN,
  (token: string, vendor: string, suppressed?: boolean | null) => ({ token, vendor, suppressed })
);
